import React, { useCallback } from 'react'
import useReactRouter from 'use-react-router'
import Modal from 'core/elements/modal'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { routes } from 'core/utils/routes'
import { deleteNetworkPolicy } from './actions'
import usePluginRouter from 'core/hooks/usePluginRouter'

export default function DeleteNetworkPolicyDialog({ rows: [networkPolicy], onClose }) {
  const { history } = useReactRouter()
  const { currentPluginId } = usePluginRouter()
  const routePath = currentPluginId === 'kubevirt' ? 'kubevirtNetworkinging' : 'networking'
  const { update: deleteFn, updating: deletingNetworkPolicy } = useUpdateAction(deleteNetworkPolicy)

  const handleDelete = useCallback(async () => {
    await deleteFn(networkPolicy)
    onClose(true)
    history.push(routes[routePath].networkPolicies.list.path())
  }, [networkPolicy, routePath])

  return (
    <Modal
      panel="dialog"
      open
      onClose={onClose}
      title={`Remove Network Policy "${networkPolicy?.name}" ?`}
      maxWidth={600}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={deletingNetworkPolicy}>
            Cancel
          </Button>
          <Button onClick={handleDelete} loading={deletingNetworkPolicy}>
            Delete
          </Button>
        </>
      }
    >
      <Text variant="body2">Your data will be lost since this action cannot be undone.</Text>
    </Modal>
  )
}
